import { render, staticRenderFns } from "./RoomBestAvailableRate.vue?vue&type=template&id=60449c54"
import script from "./RoomBestAvailableRate.vue?vue&type=script&lang=js"
export * from "./RoomBestAvailableRate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports